import "./src/index.css";
import "./src/styles/app.scss";

export const shouldUpdateScroll = () => {
  window.scrollTo(0, 0);
  return false;
};
